export function validInteger(el) {
    const int = /^\d+$/;
    return int.test(el.value) ? true : false;
}
